import React, { createRef } from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import Container from 'components/Container';
import Flex from 'components/Flex';
import Hide from 'components/Hide';
import ListingTypeLabel from 'components/ListingTypeLabel';
import SearchTile from 'components/SearchTile';
import { BodyMicro, BodySmall, H4 } from 'components/Text';
import { getCityStateString } from 'utils/address';
import { LISTING_LOCATION_TYPE } from 'utils/constants';
import { distanceInWordsToNow } from 'utils/date';
import { formatEventTime } from 'utils/idealistdayevents';

const StyledSearchTile = styled(SearchTile)`
  a {
    text-decoration: none;
    color: black;
  }
`;
type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hit: Record<string, any>;
  'data-qa-id'?: string;
};
export default class SearchHitForMap extends React.PureComponent<Props> {
  hitRef = createRef<Element>();

  render() {
    const { hit } = this.props;
    const {
      name,
      type,
      orgName,
      orgUrl,
      isFullTime,
      remoteOptions,
      city,
      state,
      country,
    } = // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.hit;
    const location = getCityStateString({
      city,
      stateCode: state,
      country,
    });
    const listingInfo = [];

    if (isFullTime !== undefined) {
      listingInfo.push(
        isFullTime ? getText('Full Time') : getText('Part Time')
      );
    }

    if (remoteOptions !== undefined) {
      listingInfo.push(LISTING_LOCATION_TYPE[remoteOptions.locationType]);
    }

    return (
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'RefObject<Element>' is not assignable to typ... Remove this comment to see the full error message
      <div ref={this.hitRef}>
        <StyledSearchTile
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          data-qa-id={this.props['data-qa-id'] || 'search-result'}
        >
          <a
            href={hit.url[USER_LOCALE]}
            target="_blank"
            rel="noopener noreferrer"
            data-qa-id="search-result-link"
          >
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
            <>
              <Flex mb="16px">
                <ListingTypeLabel listingType={type} />
              </Flex>
              <H4 mt={16} mb={0} color="greyishBrown">
                {name}
              </H4>
              <BodySmall mb="12px">
                {orgName && (
                  <>
                    {orgUrl ? (
                      <a
                        href={orgUrl[USER_LOCALE]}
                        data-qa-id="search-result-org-link"
                      >
                        {orgName}
                      </a>
                    ) : (
                      orgName
                    )}
                    {' | '}
                  </>
                )}
                {type === 'IDEALIST_DAY_EVENT' && (
                  <>
                    {formatEventTime(hit.localizedStarts, hit.localizedEnds)}
                    {' | '}
                  </>
                )}
                {location}
              </BodySmall>
              <BodyMicro color="battleshipGrey">
                <Container
                  display={['block', 'block', 'inline-block', 'inline-block']}
                >
                  {sprintf(getText('Posted %(postedAt)s'), {
                    postedAt: distanceInWordsToNow(hit.published * 1000),
                  })}
                </Container>
                {listingInfo.length > 0 && (
                  <Hide xs sm display="inline-block">
                    &nbsp;|&nbsp;
                  </Hide>
                )}
                {listingInfo.join(' | ')}
              </BodyMicro>
            </>
          </a>
        </StyledSearchTile>
      </div>
    );
  }
}
